<template>
  <div class="custom-map h-100">
    <div ref="mapDom" class="h-100"></div>
  </div>
</template>

<script>
import { BButton, BFormCheckbox } from "bootstrap-vue";
import vSelect from "vue-select";
import { ref, onMounted } from "@vue/composition-api";
import Ripple from "vue-ripple-directive";
import { Loader } from "@googlemaps/js-api-loader";
import useAppConfig from "@core/app-config/useAppConfig";
import { getCspNonce } from "@/utils/cspNonce";

export default {
  components: {
    BButton,
    vSelect,
    BFormCheckbox,
  },
  directives: {
    Ripple,
  },
  props: {
    lat: {
      type: Number,
      required: true,
    },
    lng: {
      type: Number,
      required: false,
    },
  },
  setup(props, { emit }) {
    const mapDom = ref();
    const { skin } = useAppConfig();
    let map;

    onMounted(async () => {
      const loader = new Loader({
        apiKey: window.__env.VUE_APP_GMAPS_KEY,
        version: "beta",
        libraries: ["marker", "places", "drawing"],
        language: "en",
        nonce: getCspNonce(),
      });

      await loader.load();

      const { Map } = await google.maps.importLibrary("maps");

      map = new Map(mapDom.value, {
        center: { lat: props.lat, lng: props.lng },
        zoom: 18,
        mapId: skin.value == "dark" ? "eac5c4d4f71b58d6" : "SBO",
      });

      new google.maps.marker.AdvancedMarkerElement({
        position: { lat: props.lat, lng: props.lng },
        map,
      });
    });

    return {
      mapDom,
    };
  },
};
</script>

<style lang="scss">

</style>
